export default "__VITE_ASSET__7Wtp_PYj__"